import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-eorder-landing',
  templateUrl: './eorder-landing.component.html',
  styleUrls: ['./eorder-landing.component.scss']
})
export class EorderLandingComponent {
  userChnlSub: Subscription = new Subscription();
  version = environment.version;

  constructor(
    private navigationService: NavigationService
  ) { }

  ngOnInit(): void { }

  onNavigate(dt: string) {
    switch (dt) {
      case 'privacyPolicy': {
        this.navigationService.openInNewTab("privacy-policy");
        break;
      }
      case 'tnc': {
        this.navigationService.openInNewTab("term-conditions");
        break;
      }
      default: {
        break;
      }
    }
  }
}
